import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchConsentData = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_consent/${uhid_no}`);
  return response.data;
};

export const fetchPatientData = async (uhid_no) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhid_no}`);
  return response.data;
};

export const fetchNextIpNo = async () => {
  const response = await axios.get(`${API_BASE_URL}/consent_next_ip`);
  return response.data;
};

export const createConsent = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}/submit_consent`, payload);
  return response.data;
};

export const updateConsent = async (uhid_no, payload) => {
  const response = await axios.put(`${API_BASE_URL}/update_consent/${uhid_no}`, payload);
  return response.data;
};

export const generateShareToken = async (uhid_no) => {
  const response = await axios.post(`${API_BASE_URL}/generate_for_consent_api_share_token/${uhid_no}`);
  return response.data;
};
